// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"586":"forum/components/SelectFollowLevelModal","604":"forum/components/FollowersPage","960":"forum/components/FollowingPage"}[chunkId] + ".js";
};